import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/categories";
import { getArticlesByCategory } from "@/lib/content";

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="max-w-content mx-auto">
        <SectionHeading
          eyebrow="Categories"
          title="瓜田分类"
          desc="六块瓜田，各看各的热闹。点进去就能按分类浏览最新动态。"
          align="center"
        />

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => {
            const count = getArticlesByCategory(cat.slug).length;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="group rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
              >
                <div className="flex items-center gap-4 p-5">
                  <span className="w-12 h-12 shrink-0 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center">
                    <i className={`${cat.emoji} text-2xl`}></i>
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-heading font-bold text-lg text-foreground-950 group-hover:text-primary-600 transition-colors">
                      {cat.name}
                    </h3>
                    <p className="mt-1 text-xs text-foreground-400">
                      共 {count} 条瓜 · 持续更新
                    </p>
                  </div>
                  <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-primary-500 transition-colors text-xl"></i>
                </div>
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {cat.desc}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}